module.exports = __webpack_public_path__ + "48778d13ea2064f4b1877cd931caf905.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/invite.png
// module id = 1702
// module chunks = 0